<template>
  <section class="projects-section bg-light" id="projects">
    <div class="container">
      <!-- Featured row -->
      <div class="row align-items-center no-gutters mb-4 mb-lg-5">
        <div class="col-xl-8 col-lg-7">
          <img class="img-fluid mb-3 mb-lg-0" src="../assets/img/bg-slave.webp" :alt="t('projects.heading')" />
        </div>
        <div class="col-xl-4 col-lg-5">
          <div class="featured-text text-center text-lg-left">
            <h4>{{ t('projects.heading') }}</h4>
            <p class="text-black-50 mb-0">{{ t('projects.intro') }}</p>
          </div>
        </div>
      </div>
      <!-- Project rows -->
      <ProjectRow v-for="project in projects" :key="project.key" :project="project" />
    </div>
  </section>
</template>

<script setup>
  import { useI18n } from 'vue-i18n'
  import ProjectRow from './ProjectRow.vue'
  import projects from '../data/projects.js'

  const { t } = useI18n()
</script>